import {
  Col,
  Input,
  Row,
  Select,
  DatePicker,
  Button,
  Modal,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectAllType from "../../../../components/SelectAllType";
import {
  actionMember,
  activeSelector,
  searchSelector,
} from "../../../../redux/slices/member";
import XLSX from "xlsx";
import { URL_API, _, axios, getToken, moment } from "../../../../utils";
export default function MemberFilter() {
  const dispatch = useDispatch();

  const active = useSelector(activeSelector);
  const search = useSelector(searchSelector);
  const { SET_SEARCH, SET_ACTIVE } = actionMember;

  const [query, setQuery] = useState("");

  useEffect(() => {
    setQuery(search.query);
  }, [active, search.query]);

  const onClickExport = () => {
    Modal.confirm({
      title: "ยืนยันทำรายการ",
      content: "Export Excel",
      okText: "ยืนยัน",
      cancelText: "ยกเลิก",
      zIndex: 1080,
      onOk() {
        handleExportExcel();
      },
    });
  };
  const onClickExport30Day = () => {
    Modal.confirm({
      title: "ยืนยันทำรายการ",
      content: "Export Excel ข้อมูลสมาชิกที่อยู่ในช่วงต่ออายุ",
      okText: "ยืนยัน",
      cancelText: "ยกเลิก",
      zIndex: 1080,
      onOk() {
        handleExportExcel30Day();
      },
    });
  };

  const handleExportExcel = async () => {
    const result = await axios({
      method: "GET",
      baseURL: URL_API,
      url: `/member`,
      params: {
        ...search,
        limit: 0,
        page: 0,
        member_type: active,
        offset: (search.page - 1) * search.limit,
        date_from: search.date_from
          ? moment(search.date_from).format("YYYY-MM-DD")
          : null,
        date_to: search.date_to
          ? moment(search.date_to).format("YYYY-MM-DD")
          : null,
      },
      headers: { Authorization: "Bearer " + getToken() },
    });
    const process_type =
      active === "member" ? "member_status_local" : "partner_status_local";
    const { data: textType } = await axios({
      method: "GET",
      baseURL: URL_API,
      url: `/system/master/${process_type}`,
      headers: { Authorization: "Bearer " + getToken() },
    });
    const status = textType.data?.find((e) => e.code == search?.status);
    let exportData = result?.data?.data;
    if (exportData.length !== 0) {
      let excelData = [
        ["ข้อมูลสมาชิก"],
        [
          "แสดงเฉพาะข้อมูล : ",
          search?.query,
          "วันที่ดึงข้อมูล",
          moment().format("DD/MM/YYYY HH:mm"),
        ],
        [
          "ประเภทสมาชิก",
          active === "member" ? "VIP Member" : "นักธุรกิจ",
          "สถานะ",
          search?.status ? status?.name : "ทั้งหมด",
        ],
        [
          "วันที่เริ่มต้น : ",
          search.date_from
            ? moment(search.date_from).format("DD/MM/YYYY")
            : "-",
          "วันที่สิ้นสุด : ",
          search.date_to ? moment(search.date_to).format("DD/MM/YYYY") : "-",
        ],
        [
          "ช่องทางสมัคร : ",
          search.type_register == "all"
            ? "ทุกช่องทางสมัคร"
            : search.type_register == "register-chart"
              ? "กรอกสมัครจากผัง"
              : search.type_register == "register-link"
                ? "ลิงก์สิทธิ์สมัคร"
                : "ลิงก์ผู้สมัครชำระเอง",
          "ข้อมูลการสมัคร : ",
          search.is_register_complete == "all"
            ? "ข้อมูลสมัครทุกสถานะ"
            : search.is_register_complete == "complete"
              ? "สมบูรณ์แล้ว"
              : "ยังไม่สมบูรณ์",
        ],
        [""],
        [
          "ลำดับ",
          "รหัสสมาชิก",
          "ชื่อ-นามสกุลสมาชิก",
          "รหัสผู้แนะนำ",
          "ชื่อ-นามสกุลผู้แนะนำ",
          "เบอร์โทรศัพท์",
          "อีเมล",
          "เวลาที่สมัคร",
          "ช่องทางสมัคร",
          "สถานะข้อมูลการสมัคร",
          "สถานะสมาชิก",
        ],
      ];
      exportData.forEach((n, key) => {
        excelData = [
          ...excelData,
          [
            key + 1,
            n.member_code,
            n.member_name || "-",
            n.sponsor_code || "-",
            n.sponsor_name || "-",
            n.mobile || "-",
            n.email || "-",
            n.register_date
              ? moment(n.register_date).format("DD/MM/YYYY")
              : "-",
            active === "member"
              ? "-"
              : n.type_register == 1
                ? "ลิงก์ผู้สมัครชำระเอง"
                : n.type_register == 2
                  ? "ลิงก์สิทธิ์สมัคร"
                  : "กรอกสมัครจากผัง",
            n.is_register_complete == 1 ? "สมบูรณ์แล้ว" : "ยังไม่สมบูรณ์",
            n.status_text,
          ],
        ];
      });
      var wscols = [
        { wch: 20 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
      ];
      const wb = XLSX.utils.book_new();

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      ws["!cols"] = wscols;
      XLSX.utils.book_append_sheet(wb, ws, "BlackList");
      XLSX.writeFile(
        wb,
        `Member-${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`,
      );
    } else {
      notification.warning({
        message: "ไม่มีข้อมูล",
        description: "ไม่มีข้อมูลสำหรับสร้างไฟล์ excel กรุณาตรวจสอบข้อมูล",
        top: 60,
      });
    }
  };

  const handleExportExcel30Day = async () => {
    try {
      const result = await axios({
        method: "GET",
        baseURL: URL_API,
        url: `/member/exp30day`,
        params: {
          member_type: active,
        },
        headers: { Authorization: "Bearer " + getToken() },
      });

      let exportData = result?.data?.data || [];

      if (exportData.length !== 0) {
        // จัดโครงสร้างแถวและ Header ให้ตรงตามรูปภาพ
        let excelData = [
          ["Excel ช่วงต่ออายุ"],
          ["ประเภทสมาชิก", active === "distributor" ? "นักธุรกิจ" : active === "member" ? "VIP Member" : active],
          [`ข้อมูล ณ วันที่`,
            ` ${moment().format("DD/MM/YYYY")}`],
          [`ช่วงก่อนหมดอายุ `,
            ` ${moment().format("DD/MM/YYYY")} - ${moment().add(30, "days").format("DD/MM/YYYY")}`
          ],
          [`ช่วงต่ออายุสาย`,
            ` ${moment().add(-90, "days").format("DD/MM/YYYY")} - ${moment().format("DD/MM/YYYY")}`
          ],
          [],
          [
            "Partnercode",
            "PartnerName",
            "HonorCode",
            "Status",
            "Teamname",
            "ExpireDate",
            "Enddate",
            "Days",
          ], // แถวที่ 4 (Header)
        ];

        // ใส่ข้อมูลจาก API
        exportData.forEach((n) => {
          excelData.push([
            n.partner_code || "",
            n.partner_name || "",
            n.honor_code || "",
            n.status || "",
            n.team_name || "",
            n.expire_date || "",
            n.end_date || "",
            n.days ?? "",
          ]);
        });

        // กำหนดความกว้างคอลัมน์ (Widths)
        const wscols = [
          { wch: 15 }, // Partnercode
          { wch: 30 }, // PartnerName
          { wch: 15 }, // HonorCode
          { wch: 12 }, // Status
          { wch: 18 }, // Teamname
          { wch: 15 }, // ExpireDate
          { wch: 15 }, // Enddate
          { wch: 10 }, // Days
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        ws["!cols"] = wscols;

        XLSX.utils.book_append_sheet(wb, ws, "รายชื่อสมาชิกช่วงต่ออายุ");
        XLSX.writeFile(
          wb,
          `รายชื่อสมาชิกช่วงต่ออายุ-${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`
        );
      } else {
        notification.warning({
          message: "ไม่มีข้อมูล",
          description: "ไม่มีข้อมูลสำหรับสร้างไฟล์ excel กรุณาตรวจสอบข้อมูล",
          top: 60,
        });
      }
    } catch (error) {
      console.error("Export Excel Error:", error);
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถส่งออกไฟล์ Excel ได้ กรุณาลองใหม่อีกครั้ง",
        top: 60,
      });
    }
  };

  return (
    <>

      <Row gutter={16} className="mb-2">
        <Col md={4}>
          <Select
            className="w-100"
            value={active}
            onChange={(e) => dispatch(SET_ACTIVE(e))}
          >
            <Select.Option value="distributor">นักธุรกิจ</Select.Option>
            <Select.Option value="member">VIP Member</Select.Option>
          </Select>
        </Col>

        <Col md={4}>
          <SelectAllType
            className="w-100"
            process_type={
              active === "member"
                ? "member_status_local"
                : "partner_status_local"
            }
            withAll
            allText="ทั้งหมด"
            allowClear
            value={search.status}
            onChange={(e) =>
              dispatch(
                SET_SEARCH({
                  status: e,
                  page: 1,
                })
              )
            }
          />
        </Col>

        <Col md={active === "member" ? 6 : 12}>
          <DatePicker.RangePicker
            className="w-100"
            placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
            format="DD/MM/YYYY"
            value={[search.date_from, search.date_to]}
            onChange={(e) => {
              dispatch(
                SET_SEARCH({
                  date_from: e[0] || null,
                  date_to: e[1] || null,
                  page: 1,
                })
              );
            }}
          />
        </Col>

        {active === "member" && (
          <Col md={6}>
            <Input.Search
              allowClear
              placeholder="รหัสสมาชิก, เลขบัตรประชาชน, ชื่อสมาชิก, เบอร์โทร, E-mail"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onSearch={(e) => {
                dispatch(
                  SET_SEARCH({
                    query: e,
                    page: 1,
                  })
                );
              }}
            />
          </Col>
        )}

        <Col md={4}>
          <Button type="primary" className="w-100" onClick={onClickExport}>
            Export Excel
          </Button>
        </Col>
      </Row>

      {/* แถวที่สอง: แสดง Input เพิ่มเติม (ถ้าเป็น distributor) + ปุ่ม Export 30 วันชิดขวาเสมอ */}
      <Row gutter={16} className="mb-3">
        {active === "distributor" ? (
          <>
            <Col md={12}>
              <Input.Search
                allowClear
                placeholder="รหัสสมาชิก, เลขบัตรประชาชน, ชื่อสมาชิก, เบอร์โทร, E-mail"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onSearch={(e) => {
                  dispatch(
                    SET_SEARCH({
                      query: e,
                      page: 1,
                    })
                  );
                }}
              />
            </Col>
            <Col md={4}>
              <Select
                className="w-100"
                value={search.type_register}
                onChange={(e) =>
                  dispatch(
                    SET_SEARCH({
                      type_register: e,
                      page: 1,
                    })
                  )
                }
              >
                <Select.Option value="all">ทุกช่องทางสมัคร</Select.Option>
                <Select.Option value="register-chart">
                  กรอกสมัครจากผัง
                </Select.Option>
                <Select.Option value="register-link">
                  ลิงก์สิทธิ์สมัคร
                </Select.Option>
                <Select.Option value="register-payment">
                  ลิงก์ผู้สมัครชำระเอง
                </Select.Option>
              </Select>
            </Col>
            <Col md={4}>
              <Select
                className="w-100"
                value={search.is_register_complete}
                onChange={(e) =>
                  dispatch(
                    SET_SEARCH({
                      is_register_complete: e,
                      page: 1,
                    })
                  )
                }
              >
                <Select.Option value="all">ข้อมูลสมัครทุกสถานะ</Select.Option>
                <Select.Option value="complete">สมบูรณ์แล้ว</Select.Option>
                <Select.Option value="in-complete">ยังไม่สมบูรณ์</Select.Option>
              </Select>
            </Col>
          </>
        ) : (
          /* ถ้าเป็น VIP Member ให้ดันปุ่มไปชิดขวาสุดด้วย offset (24 - 5 = 19) */
          <Col md={20} />
        )}

        {/* ปุ่ม Export 30 วัน ดึงอยู่นอกเงื่อนไข เพื่อให้แสดงทั้ง 2 สภาพแวดล้อม */}
        <Col md={4}>
          <Button
            type="primary"
            className="w-100"
            style={{
              color: "#1FC2B4",
              backgroundColor: "#FFFFFF",
              borderColor: "#1FC2B4",
            }}
            onClick={onClickExport30Day}
          >
            Excel ช่วงต่ออายุ
          </Button>
        </Col>
      </Row>
    </>
  );
}
